import React from 'react';
import { useImageCacheLocal } from '../../../../../hooks/useImageCacheLocal';
import {
  getSignedLinkUrl,
  isTencentCosUrlNeedSign,
} from '../../../ChatDSTemplate/utils';
import { handleOPenUrl } from './index';

interface SignedLinkProps {
  href?: string;
  node?: any;
  [key: string]: any;
}

/**
 * 签名链接组件
 * 对腾讯云 COS 链接进行自动签名处理后再跳转
 */
const SignedLink: React.FC<SignedLinkProps> = ({ node, href, children, ...props }) => {
  // 使用签名缓存 hook，用于 a 链接签名
  const { getSignedUrl } = useImageCacheLocal();

  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    if (!href) return;

    const needsSign = isTencentCosUrlNeedSign(href);
    const targetHref = needsSign ? href.split('?')[0] : href;
    const finalUrl = await getSignedLinkUrl(targetHref, getSignedUrl, needsSign);
    if (finalUrl) {
      handleOPenUrl({ url: finalUrl });
    }
  };

  return (
    <a
      href={href}
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      onClick={handleClick}
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    >
      {children}
    </a>
  );
};

export default SignedLink;
